export interface AnimationLoopOptions {
  frameStride?: number;
}

export function subscribeVisibilityAwareAnimationLoop(
  { frameStride = 1 }: AnimationLoopOptions,
  tick: (frameSteps: number) => void
): () => void {
  let animationId = 0;
  let running = false;
  let skippedFrames = 0;

  const loop = (): void => {
    if (document.visibilityState !== "visible") {
      running = false;
      return;
    }

    skippedFrames++;
    if (skippedFrames >= frameStride) {
      skippedFrames = 0;
      tick(frameStride);
    }
    animationId = window.requestAnimationFrame(loop);
  };

  const onVisibilityChange = (): void => {
    if (document.visibilityState === "hidden") {
      window.cancelAnimationFrame(animationId);
      running = false;
    } else if (!running) {
      running = true;
      animationId = window.requestAnimationFrame(loop);
    }
  };

  document.addEventListener("visibilitychange", onVisibilityChange);

  if (document.visibilityState === "visible") {
    running = true;
    animationId = window.requestAnimationFrame(loop);
  }

  return () => {
    document.removeEventListener("visibilitychange", onVisibilityChange);
    window.cancelAnimationFrame(animationId);
    running = false;
  };
}
